import { useQuery } from 'react-query';

import { GIQ } from 'views/App/Portal/Policy/_types/giq';
import { fetcher, baseApiUrl, ServerErrorResponse } from 'data_sources/constants';

export default function useDraftManualGIQs(
  manualId?: string,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexiverse/manual-giq/v1/manuals/${manualId}/questions`;

  return useQuery<GIQ, ServerErrorResponse>(
    ['draft_manuals_giq', manualId],
    async (): Promise<GIQ> => {
      try {
        const data = await fetcher({
          method: 'get',
          url,
        });
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      enabled: !!manualId,
      keepPreviousData: true,
    }
  );
}
